import type { UtilLinks } from 'core';

export const getDataNavBarByDeviceShowing = (
  links: UtilLinks[] | null | undefined,
  isMobile: boolean,
) => {
  if (!links) return [];

  if (isMobile) {
    return links.filter((item) => {
      if (item?.noShowMobile) return;

      return item;
    });
  }

  return links.filter((item) => !item.isOnlyMobile);
};
